// 新闻中心 API 封装（前台 + 后台）
import { getToken } from '../admin/api';

function authHeaders() {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
}

// ---- 前台 ----
export async function fetchNewsList({ category, keyword, page = 1, pageSize = 9 } = {}) {
  const q = new URLSearchParams();
  if (category) q.set('category', category);
  if (keyword) q.set('keyword', keyword);
  q.set('page', page);
  q.set('pageSize', pageSize);
  const r = await fetch(`/api/news?${q.toString()}`, { cache: 'no-store' });
  if (!r.ok) throw new Error('获取新闻列表失败');
  return r.json();
}

export async function fetchNewsDetail(slug) {
  const r = await fetch(`/api/news/${encodeURIComponent(slug)}`, { cache: 'no-store' });
  if (r.status === 404) return null;
  if (!r.ok) throw new Error('获取新闻详情失败');
  return r.json();
}

export async function fetchCategories() {
  const r = await fetch('/api/news/categories', { cache: 'no-store' });
  if (!r.ok) return [];
  return r.json();
}

// ---- 后台 ----
export async function adminNewsList({ category, keyword } = {}) {
  const q = new URLSearchParams();
  if (category) q.set('category', category);
  if (keyword) q.set('keyword', keyword);
  const r = await fetch(`/api/admin/news?${q.toString()}`, { headers: authHeaders(), cache: 'no-store' });
  if (!r.ok) throw new Error('获取后台新闻失败');
  return r.json();
}

export async function adminNewsById(id) {
  const r = await fetch(`/api/admin/news/${id}`, { headers: authHeaders(), cache: 'no-store' });
  if (!r.ok) throw new Error('读取新闻失败');
  return r.json();
}

export async function createNews(data) {
  const r = await fetch('/api/news', {
    method: 'POST', headers: { 'Content-Type': 'application/json', ...authHeaders() }, body: JSON.stringify(data),
  });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(j.error || '创建失败');
  return j;
}

export async function updateNews(id, data) {
  const r = await fetch(`/api/news/${id}`, {
    method: 'PUT', headers: { 'Content-Type': 'application/json', ...authHeaders() }, body: JSON.stringify(data),
  });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(j.error || '保存失败');
  return j;
}

export async function deleteNews(id) {
  const r = await fetch(`/api/news/${id}`, { method: 'DELETE', headers: authHeaders() });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(j.error || '删除失败');
  return j;
}

export async function uploadNewsImage(file) {
  const fd = new FormData();
  fd.append('file', file);
  const r = await fetch('/api/upload/news', { method: 'POST', headers: { ...authHeaders() }, body: fd });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(j.error || '上传失败');
  return j;
}